export default __webpack_public_path__ + "static/media/waiting_for_call.c173b33e.svg";